import { render, staticRenderFns } from "./DeploymentEdit.vue?vue&type=template&id=53af5078&"
import script from "./DeploymentEdit.vue?vue&type=script&lang=js&"
export * from "./DeploymentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports